import * as yup from 'yup'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from "react";
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import { Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import InputFileUpload from "../../../../components/inputs/yup/materialui/inputFileUpload";
import { InputArchivoEndosoMasivo } from '../models/inputArchivoEndosoMasivo';

interface IProps {
    onSubmit: (e: InputArchivoEndosoMasivo) => void
}

const FormularioArchivoEndoso = ({onSubmit} : IProps) => {

    const validationSchema: yup.ObjectSchema<InputArchivoEndosoMasivo> = yup.object().shape({
        origen: yup.string().required("Origen requerido"),
        formaPago: yup.string().required("Forma de pago requerida"),
        archivo: yup
                .mixed<File>()
                .required("Archivo es requerido")
                .test("fileExists", "Archivo es requerido", value => value instanceof File)
    })

    const {
        register,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
        watch,
    } = useForm<InputArchivoEndosoMasivo>({ resolver: yupResolver(validationSchema) })

    useEffect(() => {
        setValue("origen", "PMS")
    }, [])

    const [inputKey, setInputKey] = useState(Date.now()); //KEY PARA INPUTFILE

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            name="origen"
                            label="Origen"
                            control={control}
                            options={[
                                { value: "ASI", label: "ASI" },
                                { value: "PMS", label: "PMS" }
                            ]}
                            disabled
                            error={errors.origen}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            name="formaPago"
                            label="Forma de pago"
                            control={control}
                            options={[
                                { value: "Cheque", label: "Cheque" },
                                { value: "Efectivo", label: "Efectivo" }
                            ]}
                            error={errors.formaPago}
                        />
                    </Grid2>
                    <Grid2 container size={{ xs: 12, lg: 6 }} sx={{ marginTop: 2 }}>
                        <Grid2 size={{ xs: 12, lg: 6 }}>
                            <InputFileUpload
                                name="archivo"
                                control={control}
                                label=""
                                accept=".xls,.xlsx"
                                error={errors.archivo}
                                fileKey={inputKey}
                            />
                        </Grid2>
                        <Grid2 container size={{ xs: 12, lg: 6 }} height={"40px"}>
                            <MButton
                                type="button"
                                variant="contained"
                                startIcon={<DeleteIcon />}
                                sx={{ ml: 1 }}
                                onClick={() => {
                                    const input = document.querySelector<HTMLInputElement>('input[type="file"][name="archivo"]');
                                    if (input) input.value = '';
                                    setValue("archivo", {} as File);
                                    setInputKey(Date.now());
                                }}
                            >
                                Limpiar
                            </MButton>
                            <MButton type="submit" variant="contained" color="primary" startIcon={<ArrowCircleUpIcon />}>
                                Subir
                            </MButton>
                        </Grid2>      
                    </Grid2>
                </Grid2>       
            </form>
        </>
    )
}

export default FormularioArchivoEndoso;